var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.74755C0 1.33334 0.335786 0.997555 0.75 0.997555H17.2541C17.8722 0.997555 18.225 1.7032 17.8541 2.19762L13.6898 7.74878L17.8541 13.2999C18.225 13.7944 17.8722 14.5 17.2541 14.5L1.5 14.4996V19.2494C1.5 19.6291 1.21785 19.9429 0.851771 19.9925L0.75 19.9994C0.370304 19.9994 0.0565091 19.7172 0.00684667 19.3512L0 19.2494V1.74755ZM15.7539 2.49755H1.5V13H15.7539L12.1522 8.19884C11.9522 7.93215 11.9522 7.56541 12.1522 7.29871L15.7539 2.49755Z",
    fill: "#5CB1A3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.9febe32af547a846a387eda753677ab7.svg";
export { ForwardRef as ReactComponent };